import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { IconFileCertificate } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { QuickCreateButton } from '@/shared/components/QuickCreateButton';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface LegalTerm extends Denormalized {
  type: 'legal-terms';
  code?: string;
  title?: string;
  language?: string;
  version?: string;
  active?: boolean;
}

export const Route = createFileRoute('/_app/legals')({ component: LegalsPage });

function LegalsPage() {
  const navigate = useNavigate();
  return (
    <ResourceListPage<LegalTerm>
      title="Termini & Condizioni"
      description="Gestione documenti legali (privacy policy, T&C, cookie policy)"
      type="legal-terms"
      columns={[
        { accessorKey: 'code', header: 'Codice', size: 140 },
        { accessorKey: 'title', header: 'Titolo' },
        { accessorKey: 'language', header: 'Lingua', size: 90 },
        { accessorKey: 'version', header: 'Versione', size: 110 },
        { accessorKey: 'active', header: 'Attivo', size: 90, Cell: ({ cell }) => (cell.getValue<boolean>() ? '✓' : '—') },
      ]}
      searchField="title"
      onRowClick={(r) => void navigate({ to: '/terms/' + (r.code ?? '') })}
      emptyMessage="Nessun documento legale"
      emptyDescription="Crea il primo documento (privacy policy, T&C, cookie policy) con il bottone «Nuovo documento» nella toolbar."
      emptyIcon={IconFileCertificate}
      toolbarRight={
        <QuickCreateButton
          type="legal-terms"
          title="Nuovo documento"
          fields={[
            { name: 'code', label: 'Codice', required: true, placeholder: 'es. privacy-policy-it' },
            { name: 'title', label: 'Titolo', required: true },
            { name: 'language', label: 'Lingua', defaultValue: 'it-IT' },
            { name: 'version', label: 'Versione', defaultValue: '1.0' },
            { name: 'body', label: 'Contenuto HTML', kind: 'textarea' },
          ]}
        />
      }
    />
  );
}
